import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (params = {}, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosClient.put(`order/ListAllOrder`, params);
      const total = response.data.totalRecords;
      dispatch(setTotalOrders(total));
      return response.data.Data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data",
      );
    }
  },
);
// In OrderSlice.js
export const reciveOrder = createAsyncThunk(
  "orders/reciveOrder",
  async ({ orderData, id }, { rejectWithValue }) => {
    // Destructure from single arg
    try {
      console.log(orderData, id, "ReceiveOrder thunk");
      const response = await axiosClient.put(
        `order/ReceiveOrder/${id}`,
        orderData,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data",
      );
    }
  },
);
// update order status api call
export const updateOrderStatus = createAsyncThunk(
  "orders/updateOrderStatus",
  async ({ orderId, updatedBy, orderStatus }, { rejectWithValue }) => {
    try {
      // No body – status goes in path
      const response = await axiosClient.post(
        `order/statusUpdateOrder/${orderId}/${updatedBy}/${orderStatus}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update order status",
      );
    }
  },
);

const initialState = {
  selectedOrder: null,
  pageId: 1,
  pageSize: 12,
  selectedOrderStatus: null,
  selectedPaymentStatus: null,
  totalOrders: 0,
  allOrders: [],
  loadingOrder: false,
  errorOrder: null,
};

const OrderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setPageId: (state, action) => {
      state.pageId = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setSelectedOrderStatus: (state, action) => {
      state.selectedOrderStatus = action.payload;
    },
    setSelectedPaymentStatus: (state, action) => {
      state.selectedPaymentStatus = action.payload;
    },
    setTotalOrders: (state, action) => {
      state.totalOrders = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loadingOrder = true;
        state.errorOrder = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loadingOrder = false;
        state.allOrders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loadingOrder = false;
        state.errorOrder = action.payload;
      });
  },
});

export const {
  setSelectedOrder,
  setPageId,
  setPageSize,
  setSelectedOrderStatus,
  setSelectedPaymentStatus,
  setTotalOrders,
} = OrderSlice.actions;
export default OrderSlice.reducer;
